import { render, staticRenderFns } from "./ExternalProviderButton.vue?vue&type=template&id=07d8efa4&scoped=true&"
import script from "./ExternalProviderButton.vue?vue&type=script&lang=js&"
export * from "./ExternalProviderButton.vue?vue&type=script&lang=js&"
import style0 from "./ExternalProviderButton.vue?vue&type=style&index=0&id=07d8efa4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8efa4",
  null
  
)

export default component.exports